/*eslint-disable*/
import React, { Component } from 'react'
import { Table } from 'semantic-ui-react'
import { DateData } from '../apiInputComponent/dateData';
import { Form as FormUi, Button } from 'semantic-ui-react'
import { FieldArray, Field as Fieldmik } from 'formik';
import UploadFile from '../apiInputComponent/fileUpload'
import LoadingPlaceholder from '../placeholderComponent/loadingPlaceholder';

import moment from 'moment'

export default class DocumentTable extends Component {

    render() {
        const { onUpload, docLoading } = this.props


        if(docLoading){
            return(
                <React.Fragment>
                    <LoadingPlaceholder />
                </React.Fragment>
            )
        }else{

            return (
                <React.Fragment>
                    <Table fixed size="small" >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan="5" className="labelName w3-text-blue">Document</Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell className="labelName p-bold-600">Document Type</Table.HeaderCell>
                                <Table.HeaderCell className="labelName p-bold-600">Start Date</Table.HeaderCell>
                                <Table.HeaderCell className="labelName p-bold-600">Expiry Date</Table.HeaderCell>
                                <Table.HeaderCell className="labelName p-bold-600">Choose File</Table.HeaderCell>
                                <Table.HeaderCell className="labelName p-bold-600">Upload</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <FieldArray
                                name="docsData"
                            >
                                {fieldarrayprops => {
                                    console.log('fieldarrayprops', fieldarrayprops )
                                    const { form } = fieldarrayprops;
                                    const { initialValues, values } = form;
                                    const { docsData } = initialValues;
                                    
                                    
                                    return (
                                        <>{
                                            docsData?.map((document, index) => (
                                
                                                <Table.Row key={index}>
                                                    <Table.Cell>
                                                        {/* <Fieldmik
                                                            name={`docsData[${index}].docTypeName`}
                                                            value={docsData[index].docTypeName} /> */}
                                                        {docsData[index].docTypeName}

                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        <DateData
                                                            name={`docsData[${index}].startDate`}
                                                            autoComplete="off"
                                                            popperClassName="dateTime"
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholderText="In Date"
                                                            selected={values.docsData[index] && values.docsData[index].startDate ? values.docsData[index].startDate : ''}
                                                            selectsStart
                                                            maxDate={values.docsData[index] && values.docsData[index]['expiryDate'] ? values.docsData[index]['expiryDate'] : ''}
                                                            startDate={values.docsData[index] && values.docsData[index].startDate ? values.docsData[index].startDate : ''}
                                                            endDate={values.docsData[index] && values.docsData[index]['expiryDate'] ? values.docsData[index]['expiryDate'] : ''}
                                                            customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />} />
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        <DateData
                                                            name={`docsData[${index}].expiryDate`}
                                                            selected={values.docsData[index] && values.docsData[index].expiryDate ? values.docsData[index].expiryDate : ''}
                                                            selectsEnd
                                                            startDate={values.docsData[index] && values.docsData[index]['startDate'] ? values.docsData[index]['startDate'] : ''}
                                                            endDate={values.docsData[index] && values.docsData[index].expiryDate ? values.docsData[index].expiryDate : ''}
                                                            minDate={values.docsData[index] && values.docsData[index]['startDate'] ? values.docsData[index]['startDate'] : ''}
                                                            autoComplete="off"
                                                            popperClassName="dateTime"
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholderText="Out Date"
                                                            customInput={<FormUi.Input autoComplete="off" icon="time" className="dateWidth" iconPosition="left" />} />
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        <Fieldmik name={`docsData[${index}].fileUpload`} component={UploadFile} typer={[".pdf"]} buttonName={ form.values.docsData && form.values.docsData[index] && form.values.docsData[index].fileUpload ? "Selected" : 'Choose File'} />
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        <Button disabled={values.docsData[index].fileUpload ? false : true} type='button' onClick={() => onUpload(values, index)} icon="upload" basic color="green" size="mini" />
                                                    </Table.Cell>
                                                </Table.Row>
                                            ))
                                    }
                                    </>)
                                }}

                            </FieldArray>
                        </Table.Body>
                    </Table>
                </React.Fragment>
            )
        }
    }
}
